import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import * as React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export interface IWidgetPreviewPageProps {}

export default function WidgetPreviewPage(props: IWidgetPreviewPageProps) {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  return (
    <div className="w-screen h-screen bg-white space-y-8 py-20 light">
      <div className="px-20 text-black space-y-4">
        <div className="flex items-center gap-4">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            size="icon"
            className="h-6 w-6 shrink-0"
          >
            <ChevronLeft className="h-4 w-4 text-white" />
            <span className="sr-only">Back</span>
          </Button>
          <h1 className="text-2xl font-semibold leading-none tracking-tight">
            {search.get("selection") ?? "Mon widget"}
          </h1>
        </div>
        <p>Prévisualisation du widget en temps réel</p>
      </div>
      <tnj-widget
        data-app_secret={search.get("app_secret")}
        data-selection={search.get("selection")}
      ></tnj-widget>
    </div>
  );
}
